document.addEventListener("DOMContentLoaded", function() {
  const container = document.getElementById("locator-app-embed");
  if (container) {
    const header = container.querySelector("#page-header h1");
    if (header) {
      const h2 = document.createElement("h2");
      h2.innerHTML = header.innerHTML; // Copy the content
      header.replaceWith(h2); // Replace <h1> with <h2>
    }
  }
});
